// BIE Behaviour Tracker — signal scoring only (no launcher/panel UI)
// Triggers open B.I.B chat widget via custom event when exit intent fires
// Mobile devices are excluded — the widget fills the whole screen and is too intrusive
(function () {
  'use strict';

  // Never auto-open on mobile/touch devices
  if (window.innerWidth < 768 || ('ontouchstart' in window && window.innerWidth < 1024)) return;

  var PAGE_URL = window.location.pathname;
  var IS_PRODUCT = /\/products\//.test(PAGE_URL);
  var IS_CART    = /\/cart/.test(PAGE_URL);

  var score = 0;
  var triggered = false;
  var startTime = Date.now();
  var lastScrollY = window.scrollY;
  var lastScrollTime = Date.now();

  // ── Scoring helpers ──────────────────────────────────────────────────────
  var triggerThreshold = 80;   // raised — harder to accidentally hit
  var minTimeOnPage = 20000;   // 20s minimum before anything fires

  function addScore(points) {
    score += points;
    if (!triggered && score >= triggerThreshold && (Date.now() - startTime) >= minTimeOnPage) {
      triggerIntervention();
    }
  }

  function triggerIntervention() {
    if (triggered) return;
    triggered = true;

    // Notify backend (non-blocking)
    try {
      fetch('https://bie-prospecting-bot-production.up.railway.app/api/intervention', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          url: window.location.href,
          score: score,
          pageType: IS_PRODUCT ? 'product' : IS_CART ? 'cart' : 'other',
          timestamp: new Date().toISOString()
        })
      }).catch(function () {});
    } catch (e) {}

    // Open B.I.B widget
    window.dispatchEvent(new CustomEvent('bie-open-chat'));
  }

  // ── Signals — only active on product / cart pages ────────────────────────
  if (IS_PRODUCT || IS_CART) {

    // Rapid scroll detection
    window.addEventListener('scroll', function () {
      var now = Date.now();
      var dy = Math.abs(window.scrollY - lastScrollY);
      var dt = now - lastScrollTime;
      if (dt > 0 && dt < 300 && dy > 150) addScore(8);
      lastScrollY = window.scrollY;
      lastScrollTime = now;
    }, { passive: true });

    // Tab hidden / switching away
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) addScore(12);
    });

    // Product image hover dwell (product pages only)
    if (IS_PRODUCT) {
      var hoverTimer = null;
      document.addEventListener('mouseover', function (e) {
        var img = e.target.closest && e.target.closest('.product__media img, .product-media img, [data-product-image]');
        if (img) {
          hoverTimer = setTimeout(function () { addScore(10); }, 3000);
        }
      });
      document.addEventListener('mouseout', function (e) {
        var img = e.target.closest && e.target.closest('.product__media img, .product-media img, [data-product-image]');
        if (img && hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      });
    }

    // Cart dwell (60 s on cart = direct trigger regardless of score)
    if (IS_CART) {
      setTimeout(function () {
        if (!triggered) triggerIntervention();
      }, 60000);

      // Cart form hesitation
      var formStarted = false;
      document.addEventListener('focusin', function (e) {
        if (e.target.form && !formStarted) { formStarted = true; addScore(15); }
      });
    }

    // Back-button intent (popstate)
    window.addEventListener('popstate', function () { addScore(20); });
  }

  // ── Exit intent — mouse leaves toward top of screen ─────────────────────
  // Desktop only (already guarded at the top). Requires minTimeOnPage before doing anything.
  document.addEventListener('mouseleave', function (e) {
    if (e.clientY <= 10 && !triggered && (Date.now() - startTime) >= minTimeOnPage) {
      if (IS_PRODUCT || IS_CART) {
        addScore(25);
      } else {
        triggerIntervention();
      }
    }
  });

})();
